<template>
    <div>
        <div class="card-content">
            <div class="row">
                <div class="col-10">
                    <b-form-input id="name-input"
                                  class="o-form"
                                  type="text"
                                  v-model="text"
                                  required
                                  :placeholder="localPlaceholder">
                    </b-form-input>
                </div>
                <div class="col-2">
                    <a href="javascript:void(0)" @click="addClicked">+</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {
        MUSIC_ACTION_CREATE_MUSIC,
        MUSIC_TYPE_CEREMONY_MUSICS,
        MUSIC_TYPE_CEREMONY_BANDS,
        MUSIC_TYPE_OBSERVANCE_MUSICS,
        MUSIC_TYPE_OBSERVANCE_BANDS,
        MUSIC_NAMESPACE
    } from '../../../store/modules/music-types'
    import i18n from '../../../assets/i18n/lang'

    export default {
        name: 'Music',
        data: function () {
            return {
                text: ''
            }
        },
        props: ['musicId', 'category'],
        computed: {
            localPlaceholder: {
                get () {
                    if (this.category === MUSIC_TYPE_CEREMONY_MUSICS || this.category === MUSIC_TYPE_OBSERVANCE_MUSICS) {
                        return i18n.t('ceremony.music.musicPlaceholder')
                    } else if (this.category === MUSIC_TYPE_CEREMONY_BANDS || this.category === MUSIC_TYPE_OBSERVANCE_BANDS) {
                        return i18n.t('ceremony.music.bandPlaceholder')
                    }
                },
                set (value) {}
            }
        },
        methods: {
            ...mapActions(MUSIC_NAMESPACE, {
                addMusic: MUSIC_ACTION_CREATE_MUSIC
            }),
            addClicked () {
                this.addMusic({musicType: this.category, musicText: this.text})
                this.text = ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .button-div {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/funeral/music/MusicAddComponent.vue